/* eslint-disable no-unused-vars */
import FullscreenIcon from "@svg/new-design/player/fullscreen";
import PictureInPictureIcon from "@svg/new-design/player/pic-in-pic";
import PlayIcon from "@svg/new-design/player/play";
import RefreshLeftIcon from "@svg/new-design/player/refresh-left";
import VolumeOffIcon from "@svg/new-design/player/volume-off";
import VolumeUpIcon from "@svg/new-design/player/volume-up";

import { FC, useState, MouseEvent, RefObject } from "react";
import MenuItem from "./menu-item";
import InputRange from "./menu-range-slider";
import { SpeedRate } from "types/player";
import { createPortal } from "react-dom";
import PauseIcon from "@svg/new-design/player/pause";

interface Props {
  left: number;
  top: number;
  isMuted?: boolean;
  speedRateChangeHandler: (speed: SpeedRate) => void;
  toggleMuteHandler: () => void;
  togglePlayByClickHandler: (
    e?: MouseEvent<HTMLElement | SVGSVGElement> | KeyboardEvent
  ) => Promise<void>;
  togglePipHandler: () => Promise<void>;
  pipEnable: boolean;
  fullScreenEnable: boolean;
  toggleFullscreenHandler: () => void;
  targetRef: RefObject<HTMLDivElement | null>;
  startPlayer: () => void;
  currentSpeed: SpeedRate;
  isPlaying: boolean;
  closeMenu: () => void;
}
const RightClickMenu: FC<Props> = ({
  left,
  top,
  isMuted = false,
  toggleFullscreenHandler,
  speedRateChangeHandler,
  togglePipHandler,
  togglePlayByClickHandler,
  pipEnable,
  fullScreenEnable,
  toggleMuteHandler,
  targetRef,
  startPlayer,
  currentSpeed,
  isPlaying,
  closeMenu,
}) => {
  const [speed, setSpeed] = useState<SpeedRate>(currentSpeed);
  const menuItemList = [
    {
      icon: isPlaying ? (
        <PauseIcon className="h-4     w-4    " />
      ) : (
        <PlayIcon className="h-4     w-4    " />
      ),
      title: isPlaying ? "توقف" : "پخش",
      onclick: togglePlayByClickHandler,
      enabled: true,
    },
    {
      icon: isMuted ? (
        <VolumeOffIcon className="h-4     w-4    " />
      ) : (
        <VolumeUpIcon className="h-4     w-4    " />
      ),
      title: isMuted ? "صدا روشن" : "بی صدا",
      onclick: toggleMuteHandler,
      enabled: true,
    },
    {
      icon: <RefreshLeftIcon className="h-4     w-4    " />,
      title: "شروع مجدد ویدیو",
      onclick: startPlayer,
      enabled: true,
    },
    {
      icon: <FullscreenIcon className="h-4     w-4    " />,
      title: "تمام صفحه",
      onclick: toggleFullscreenHandler,
      enabled: fullScreenEnable,
    },
    {
      icon: <PictureInPictureIcon className="h-4     w-4    " />,
      title: "تصویر در تصویر",
      onclick: togglePipHandler,
      enabled: pipEnable,
    },
  ];
  return createPortal(
    <div
      ref={targetRef}
      className="bg-fds-primary z-[9999] w-48 rounded-lg border min-w-14 py-2  shadow-lg absolute"
      style={{
        left,
        top,
      }}
      dir="ltr"
    >
      {menuItemList
        .filter((item) => item.enabled)
        .map((menuItm, idx) => (
          <>
            <MenuItem
              key={idx}
              title={menuItm.title}
              icon={menuItm.icon}
              onClick={() => {
                menuItm.onclick();
                closeMenu();
              }}
            />

            {(idx === 2 || idx === 4) && (
              <div className="border-t border-fds-cart my-1" />
            )}
          </>
        ))}

      <InputRange
        min={0.25}
        max={2}
        onChange={(val: SpeedRate) => {
          setSpeed(val);
          speedRateChangeHandler(val);
        }}
        value={speed}
      />
    </div>,

    document.getElementsByClassName("courseItemPageSelector")[0] ||
      document.body
  );
};

export default RightClickMenu;
